































































































































import Vue from 'vue'
import LocationForm from '@/UI/Auction/PersonalData/LocationForm.vue'
import NonEmptyInput from '@/UI/Auction/PersonalData/Fields/NonEmptyInput.vue'
import NifInput from '@/UI/Shared/NifInput.vue'
import SurnameByNifInput from '@/UI/Shared/SurnameByNifInput.vue'
import StreetTypeSelector from '@/UI/Auction/PersonalData/Fields/StreetTypeSelector.vue'
import PhoneField from '@/UI/Shared/PhoneField.vue'
import EmailField from '@/UI/Shared/EmailField.vue'
import { PersonalData } from '@/Infrastructure/Store/Auction/PersonalData'

export default Vue.extend({
  name: 'PersonalDataForm',
  components: {
    LocationForm,
    SurnameByNifInput,
    NifInput,
    StreetTypeSelector,
    PhoneField,
    EmailField,
    NonEmptyInput
  },
  props: {
    formDisabled: {
      type: Boolean,
      default: false
    },
    previousData: {
      type: Object as () => PersonalData,
      required: true
    }
  },
  data () {
    return {
      name: '',
      firstSurname: '',
      secondSurname: '',
      nif: '',
      streetType: '',
      streetTypeName: '',
      street: '',
      streetNumber: '',
      block: '',
      floor: '',
      door: '',
      parish: '',
      parishName: '',
      place: '',
      placeName: '',
      postalCode: '',
      province: '',
      provinceName: '',
      county: '',
      countyName: '',
      local: '',
      phone: '',
      fax: '',
      mobile: '',
      email: ''
    }
  },
  computed: {
    selectorStreetStatus (): string {
      if (this.streetType !== '') {
        return 'required ok'
      }
      return 'required'
    }
  },
  watch: {
    previousData (newValue: PersonalData) {
      this.parsePersonalData(newValue)
    }
  },
  created () {
    this.parsePersonalData(this.previousData)
  },
  methods: {
    parsePersonalData (data: PersonalData): void {
      this.name = data.name
      this.firstSurname = data.firstSurname
      this.secondSurname = data.secondSurname
      this.nif = data.nif
      this.streetType = data.streetType
      this.streetTypeName = data.streetTypeName
      this.street = data.street
      this.streetNumber = data.streetNumber
      this.block = data.block
      this.floor = data.floor
      this.door = data.door
      this.parish = data.parish
      this.parishName = data.parishName
      this.place = data.place
      this.placeName = data.placeName
      this.postalCode = data.postalCode
      this.province = data.province
      this.provinceName = data.provinceName
      this.county = data.county
      this.countyName = data.countyName
      this.local = data.local
      this.phone = data.phone
      this.fax = data.fax
      this.mobile = data.mobile
      this.email = data.email
    },
    onPropertyUpdated ($event: { [key: string]: string }) {
      for (const dataKey in $event) {
        this.$data[dataKey] = $event[dataKey]
      }
      this.emitUpdatedData()
    },
    emitUpdatedData () {
      this.$emit('personal-data-updated', {
        name: this.name,
        firstSurname: this.firstSurname,
        secondSurname: this.secondSurname,
        nif: this.nif,
        streetType: this.streetType,
        streetTypeName: this.streetTypeName,
        street: this.street,
        streetNumber: this.streetNumber,
        block: this.block,
        floor: this.floor,
        door: this.door,
        parish: this.parish,
        parishName: this.parishName,
        place: this.place,
        placeName: this.placeName,
        postalCode: this.postalCode,
        province: this.province,
        provinceName: this.provinceName,
        county: this.county,
        countyName: this.countyName,
        local: this.local,
        phone: this.phone,
        fax: this.fax,
        mobile: this.mobile,
        email: this.email
      })
    }
  }
})
